<template>
  <div class="mobile_form" style="text-align: justify;">
    <div class="mobile_filtter" v-if="isHome !== undefined && isHome === 'home'">
      <div class="container">
        <div class="d-flex text-white">
          <div class="p-2">
            <a v-b-modal.filterbox>
              <i class="fas fa-filter"></i>{{ $t('search-result.filter') }}</a>
          </div>
          <div class="p-2">
            <a v-b-modal.filtercont data-target="#filtercont"><i class="fas fa-list"></i>{{ $t('search-result.list-view') }}</a>
          </div>
          <div class="p-2">
              <button class="mobile-reset" @click="$emit('forceUpdate')">{{ $t('home.show-all') }}</button>
            </div>
        </div>
      </div>

      <!-- Modal -->
      <div class="search_popuparea">
        <b-modal id="searchmodal" hide-footer ref="searchmodal">
          <template #modal-title>
            <h5 class="modal-title" id="exampleModalLabel">
              <img class="img-fluid" src="assets/img/logo.png" alt="logo" />
            </h5>
          </template>

          <div class="titelbox my-3">{{ $t('search-result.search') }}</div>
          <SearchTabs @closeSearchMobile="turnOffModal" />
        </b-modal>

        <b-modal id="filtercont" hide-footer ref="filtercont">
          <template #modal-title>
            <h5 class="modal-title" id="exampleModalLabel">
              <img class="img-fluid" src="assets/img/logo.png" alt="logo" />
            </h5>
          </template>

          <div class="titelbox my-3">{{ $t('search-result.list-view') }}</div>
          <SortButtons :buttonList="sortButtonList" @updateSort="doSort" />
        </b-modal>

        <b-modal id="filterbox" hide-footer ref="filterbox">
          <template #modal-title>
            <h5 class="modal-title" id="exampleModalLabel">
              <img class="img-fluid" src="assets/img/logo.png" alt="logo" />
            </h5>
          </template>

          <template #default="{ hide }">
            <div class="titelbox my-3" @click="hide()">{{ $t('search-result.filter') }}</div>
            <filter-panel
              :options="optionsHome"
              @change="filterByOption"
              :route="`home`"
              @closeSearchMobile="turnOffModal1"
            />
          </template>
        </b-modal>

        <div
          class="modal"
          id="filterbox"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">
                  <img class="img-fluid" src="assets/img/logo.png" alt="logo" />
                </h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="titelbox">{{ $t('search-result.filter') }}</div>
              <div class="modal-body">
                <div class="accordion sidePanel" id="accordionParent">
                  <div class="card">
                    <div class="card-header" id="headingStarRating">
                      <h2 class="mb-0">
                        <button
                          class="btn btn-link"
                          type="button"
                          data-toggle="collapse"
                          data-target="#starRating"
                          aria-expanded="false"
                          aria-controls="starRating"
                        >
                          <!-- collapsed -->
                          {{ $t('search-result.one-trip-found') }}
                        </button>
                      </h2>
                    </div>
                    <div
                      id="starRating"
                      class="collapse show"
                      aria-labelledby="headingStarRating"
                      data-parent=""
                    >
                      <div class="card-body">
                        <ul class="list-group list-group-flush filter-hotel">
                          <li class="list-group-item">
                            <div class="custom-control custom-radio">
                              <input
                                type="radio"
                                class="custom-control-input"
                                id="radioDayOne"
                                name="radio-stacked"
                                required
                              />
                              <label
                                class="custom-control-label"
                                for="radioDayOne"
                              >
                                <span>{{ $t('search-result.recommended') }}</span>
                                <span class="text-muted mr-3">$1199</span>
                              </label>
                            </div>
                          </li>
                          <li class="list-group-item">
                            <div class="custom-control custom-radio">
                              <input
                                type="radio"
                                class="custom-control-input"
                                id="radioDayTwo"
                                name="radio-stacked"
                                required
                              />
                              <label
                                class="custom-control-label"
                                for="radioDayTwo"
                              >
                                <span>{{ $t('search-result.special') }}</span>
                                <span class="text-muted mr-3">$999</span>
                              </label>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile_filtter" v-else>
      <div class="container">
        <div class="d-flex text-white">
          <div class="p-2">
            <a v-b-modal.filterbox>
              <i class="fas fa-filter"></i>{{ $t('search-result.filter') }}</a>
          </div>
          <div class="p-2">
            <a v-b-modal.filtercont data-target="#filtercont"><i class="fas fa-list"></i>{{ $t('search-result.list-view') }}</a>
          </div>
          <div class="p-2 flex-grow-1">
            <a class="searchbox" v-b-modal.searchmodal><i class="fas fa-search"></i>{{ $t('search-result.search') }}</a>
          </div>
        </div>
      </div>

      <!-- Modal -->
      <div class="search_popuparea">
        <b-modal id="searchmodal" hide-footer ref="searchmodal">
          <template #modal-title>
            <h5 class="modal-title" id="exampleModalLabel">
              <img class="img-fluid" src="assets/img/logo.png" alt="logo" />
            </h5>
          </template>

          <div class="titelbox my-3">{{ $t('search-result.search') }}</div>
          <SearchTabs @closeSearchMobile="turnOffModal" v-if="kindTheme === 0"/>
          <SearchTabs2 @closeSearchMobile="turnOffModal" v-else/>
        </b-modal>

        <b-modal id="filtercont" hide-footer>
          <template #modal-title>
            <h5 class="modal-title" id="exampleModalLabel">
              <img class="img-fluid" src="assets/img/logo.png" alt="logo" />
            </h5>
          </template>

          <div class="titelbox my-3">{{ $t('search-result.list-view') }}</div>
          <SortButtons :buttonList="sortButtonList" @updateSort="doSort" />
        </b-modal>

        <b-modal id="filterbox" hide-footer>
          <template #modal-title>
            <h5 class="modal-title" id="exampleModalLabel">
              <img class="img-fluid" src="assets/img/logo.png" alt="logo" />
            </h5>
          </template>

          <template #default="{ hide }">
            <div class="titelbox my-3" @click="hide()">{{ $t('search-result.filter') }}</div>

            <filter-panel
              :options="filterOptions"
              @change="filterByOption"
            />
          </template>
        </b-modal>

        <div
          class="modal"
          id="filterbox"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">
                  <img class="img-fluid" src="assets/img/logo.png" alt="logo" />
                </h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="titelbox">{{ $t('search-result.filter') }}</div>
              <div class="modal-body">
                <div class="accordion sidePanel" id="accordionParent">
                  <div class="card">
                    <div class="card-header" id="headingStarRating">
                      <h2 class="mb-0">
                        <button
                          class="btn btn-link"
                          type="button"
                          data-toggle="collapse"
                          data-target="#starRating"
                          aria-expanded="false"
                          aria-controls="starRating"
                        >
                          <!-- collapsed -->
                          {{ $t('search-result.one-trip-found') }}
                        </button>
                      </h2>
                    </div>
                    <div
                      id="starRating"
                      class="collapse show"
                      aria-labelledby="headingStarRating"
                      data-parent=""
                    >
                      <div class="card-body">
                        <ul class="list-group list-group-flush filter-hotel">
                          <li class="list-group-item">
                            <div class="custom-control custom-radio">
                              <input
                                type="radio"
                                class="custom-control-input"
                                id="radioDayOne"
                                name="radio-stacked"
                                required
                              />
                              <label
                                class="custom-control-label"
                                for="radioDayOne"
                              >
                                <span>{{ $t('search-result.recommended') }}</span>
                                <span class="text-muted mr-3">$1199</span>
                              </label>
                            </div>
                          </li>
                          <li class="list-group-item">
                            <div class="custom-control custom-radio">
                              <input
                                type="radio"
                                class="custom-control-input"
                                id="radioDayTwo"
                                name="radio-stacked"
                                required
                              />
                              <label
                                class="custom-control-label"
                                for="radioDayTwo"
                              >
                                <span>{{ $t('search-result.special') }}</span>
                                <span class="text-muted mr-3">$999</span>
                              </label>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="search-box-container">
      <TextSearchBox @updateSearch="updateSearch"/>
    </div> -->
  </div>
</template>

<script>
import { VBModal, BModal } from 'bootstrap-vue';
import agencyMarketer from '@/mixins/agencyMarketer';

export default {
  name: 'MobileFilter',
  mixins: [agencyMarketer],
  components: {
    BModal,
    SearchTabs: () => import('@/components/search/searchTabs/SearchTabsTheme0'),
    SearchTabs2: () => import('@/components/search/searchTabs/SearchTabsTheme2'),
    // SearchTab: () => import('@/components/search/SearchTab'),
    // SearchTabHO: () => import('@/components/search/SearchTabHO'),
    SortButtons: () => import('@/components/searchResult/atoms/SortButtons'),
    FilterPanel: () => import('@/components/searchResult/atoms/FilterPanel'),
    // TextSearchBox: () => import('@/components/searchResult/atoms/TextSearchBox'),
  },
  props: {
    sortButtonList: Array,
    filterOptions: Object,
    isHome: String,
    optionsHome: Object,
  },
  directives: {
    'b-modal': VBModal,
  },
  data() {
    return {
      filterConditions: {},
    };
  },
  methods: {
    doSort(arr) {
      this.$emit('updateSort', arr);
      this.$set(this.filterConditions, 'sort', arr[1]);
      this.$emit('filterChange', this.filterConditions);
    },
    turnOffModal() {
      this.$refs.searchmodal.hide();
    },
    turnOffModal1() {
      this.$refs.filterbox.hide();
    },
    updateSearch(str) {
      this.$emit('updateSort', ['hotelName', str]);
    },
    filterByOption(condition) {
      this.$emit('filterChange', condition);
    },
  },
};
</script>

<style>
.modal {
  direction: rtl;
}
.modal-dialog {
  width: calc(100% - 1rem);
}
.modal-header .close {
  padding: 0;
  margin: 0;
}
#searchmodal.modal .modal-body,
#filtercont.modal .modal-body,
#filterbox.modal .modal-body {
  display: block;
}

.theme1 .mobile_filtter {
    background-color: #1993c8;
}

/* Mobile search-modal cleanup per Ofir 2026-08-16 —
   the previous layout left a huge empty gap under the "חפש דיל" title
   because the modal-body padded top by ~2rem and SearchTabs added its own
   margin. Trim both, and give the supplier chips row a tight top gap so it
   sits right under the search button on mobile. */
@media (max-width: 767px) {
  #searchmodal.modal .modal-body {
    padding: 6px 10px 10px !important;
  }
  #searchmodal.modal .titelbox {
    margin-top: 0 !important;
    margin-bottom: 6px !important;
  }
  #searchmodal.modal .breadcrumb,
  #searchmodal.modal .breadcrumb-item {
    padding: 0 !important;
    margin: 0 !important;
    background: transparent !important;
    font-size: 12px;
  }
  .supplier-picker-row--mobile {
    margin: 6px 0 0 !important;
    padding: 0 !important;
  }
  .supplier-picker-row--mobile .supplier-checkboxes,
  .supplier-picker-row--mobile > * {
    justify-content: center;
    flex-wrap: wrap;
  }
}
</style>

<style scoped>
.modal-title {
  filter: invert(0.8);
  filter: invert(30%) sepia(50%) saturate(6327%) hue-rotate(165deg)
    brightness(61%);
  -webkit-filter: invert(30%) sepia(50%) saturate(6327%) hue-rotate(165deg)
    brightness(91%);
  -moz-filter: invert(30%) sepia(50%) saturate(6327%) hue-rotate(165deg)
    brightness(61%);
  max-width: 130px;
}
.modal-header {
  padding: 14px;
  border-bottom: 1px solid #e9ecef;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  margin: 0;
}
.modal .titelbox {
  background-color: #1eaae8;
  text-align: center;
  font-size: 16px;
  color: #fff;
  padding: 8px;
  box-sizing: border-box;
  line-height: 17px;
}
.search-box-container{
  padding: 10px;
}
@media (max-width: 768px) {
  .mobile_form {
    display: block;
  }
  .mobile-reset {
    padding: 0px 24px;
    border-radius: 50px;
    border: 1px solid rgb(0, 97, 171);
    border: 1px solid rgba(var(--theme-primary));
    cursor: pointer;
  }
}
</style>
